import GoBack from './GoBack';
import React, { useContext, useState } from 'react'
import AuthContext from '../../context/auth/authContext'
import Secure from '../../images/secure_2.jpg'
function SubmitForm() {
    const authContext = useContext(AuthContext);
    const { toggleModal, step, goBack, getContract } = authContext;
    const handleClick = (e, type) => {
        e.preventDefault();
        toggleModal(type);
    }
    const initialState = {
        text: 'Your Information is Secure',
        img: Secure
    }
    const [fields, setFields] = useState(initialState);

    const handleSSL = (e) => {
        e.preventDefault();
        setFields({
            ...fields, text: 'Checking SSL'
        });
        setTimeout(function () {
            setFields({
                ...fields, text: 'HTTPS Secured'
            });
        }, 2500);
    }
    const handleSwitch = (step) => {
        switch (step) {
            // case 9:
            //     return (
            //         <button type="submit" className="btn btn-primary review_btn" id="submitForm">Review &amp; Sign <div className="arrow"><i className="fas fa-chevron-right"></i></div>
            //         </button>
            //     );
            case 11:
                return (
                    <a href="#" className="btn btn-primary review_btn" onClick={(e) => getContract(e)} id="submitForm">Review &amp; Sign <i className="fas fa-chevron-right"></i>
                    </a>
                );
            default:
                return (
                    <button type="submit" className="btn btn-primary submit_btn" id="submitForm">Continue <i className="fas fa-chevron-right"></i>
                    </button>
                )
        }
    }
    return (
        <div className="info mt-2">
            <div className="row align-items-center justify-content-center text-center">
                <div className="col-md-12">

                    <div className="bottom-buttons justify-content-center">
                        {step > 2 ?
                            <GoBack goBack={goBack} step={step} />
                            : ''}
                        {handleSwitch(step)}

                    </div>
                </div>
                <div className="col-md-10">
                    {step === 10 ?
                        <p className="text-center pt-3 pt-md-0 pb-md-0 mb-md-0 agrees">
                            By submitting this form, you agree to our <a href="/" onClick={(e) => handleClick(e, 'privacy')}>Privacy policy</a>. Your information is confidential and secure.</p>
                        : null}
                </div>
                <div className="col-12">
                    <div className="ssl_div mt-4" onClick={(e) => handleSSL(e)}>
                        <img src={fields.img} className="img-fluid" alt="secure_2" />
                        <span>{fields.text}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SubmitForm
